import { render, staticRenderFns } from "./GameItemsAdd.vue?vue&type=template&id=2fcfa163&"
import script from "./GameItemsAdd.vue?vue&type=script&lang=js&"
export * from "./GameItemsAdd.vue?vue&type=script&lang=js&"
import style0 from "./GameItemsAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports